/**
 * Staff Manager Multi-Select Implementation using Tom Select
 *
 * This module initializes Tom Select on Jobs Managed and Farms Managed
 * select fields for the Staff Manager form.
 */

import TomSelect from 'tom-select';

/**
 * Initialize Tom Select on staff manager form select fields
 */
function initializeStaffManagerSelects() {
	// Initialize Jobs Managed select
	const jobsSelect = document.getElementById('id_jobs');
	if (jobsSelect) {
		new TomSelect(jobsSelect, {
			plugins: ['remove_button', 'drag_drop'],
			placeholder: 'Select jobs to manage...',
			maxItems: null, // Allow unlimited selections
			closeAfterSelect: false,
			searchField: ['text'],
			sortField: 'text',
			shouldShow: function(data) {
				return data.text && data.text.trim() !== '';
			},
			render: {
				item: function (data, escape) {
					return '<div class="item">' +
						'<span class="badge bg-primary me-1">' +
						escape(data.text) +
						'</span>' +
						'</div>';
				},
				option: function (data, escape) {
					return '<div class="option">' +
						'<span>' + escape(data.text) + '</span>' +
						'</div>';
				}
			}
		});
	}

	// Initialize Farms Managed select
	const farmsSelect = document.getElementById('id_farms');
	if (farmsSelect) {
		new TomSelect(farmsSelect, {
			plugins: ['remove_button', 'drag_drop'],
			placeholder: 'Select farms to manage...',
			maxItems: null, // Allow unlimited selections
			maxOptions: null, // Show all options (no limit)
			closeAfterSelect: false,
			searchField: ['text'],
			sortField: 'text',
			preload: 'focus', // Load all options when focused/clicked
			openOnFocus: true, // Open dropdown when field receives focus
			shouldShow: function(data) {
				return data.text && data.text.trim() !== '';
			},
			load: function(query, callback) {
				// Show all options when dropdown opens (empty query)
				if (!query.length) {
					callback();
					return;
				}
				// For searches, use default filtering
				callback();
			},
			render: {
				item: function (data, escape) {
					return '<div class="item">' +
						'<span class="badge bg-secondary me-1">' +
						escape(data.text) +
						'</span>' +
						'</div>';
				},
				option: function (data, escape) {
					return '<div class="option">' +
						'<span>' + escape(data.text) + '</span>' +
						'</div>';
				}
			}
		});
	}
}

/**
 * Initialize when DOM is ready
 */
document.addEventListener('DOMContentLoaded', function () {
	// Only initialize if we're on a staff manager form page
	if (document.getElementById('staffManagerForm')) {
		initializeStaffManagerSelects();
	}
});

export default initializeStaffManagerSelects;